// @flow
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { PAGE_HOME } from 'Utils/request/requestDictionary';
import * as configQueries from 'Views/configQueries';
import { addTranslationKeys } from 'Src/i18n';
import dynamicPageService from 'Server/dynamicPageService';

export const fetchLegacyHomeConfig = (appContext: AppContext): Promise<{ config: CMSContent }> => {
  const legacyQuery = `query {
        config {
          zone {
            description href name subTitle order
            zone {
              name image href
              zone { name href }
            }
          }
          discoverClubMed { order }
          ${configQueries.searchRemote()}
          ${configQueries.resort(appContext)}
          ${configQueries.price()}
          ${configQueries.faceting()}
          common { next previous close }
          home {
            immersive {
              backgroundURL
              title
              subtitle
              size
              contentPosition
              link {
                url
                label
              }
              theming {
                titleColor
                subtitleColor
                countdownColor
                linkColor
                linkBackgroundColor
              }
              countdown {
                dateTimeEnd
                days
                hours
                minutes
                seconds
              }
            }
            pushedBlocks
            sections
            seo {
              title
              meta {
                name
                content
              }
              hrefLang {
                url
                locale
              }
            }
          }
          footer { seo { description } }
          seo {
            contacts {
              type
              phoneNumber
              hearingImpairedSupported
              tollFree
            }
          }
        }
      }`;

  return graphQLClient
    .runQuery(legacyQuery, appContext, { requestName: PAGE_HOME })
    .then(({ config }) => {
      addTranslationKeys(config);
      return { config };
    });
};

const fetchHomeSeo = ({ appContext }: { appContext: AppContext }) => {
  const seoQuery = `query {
    config {
      footer { seo { description } }
      seo {
        contacts {
          type
          phoneNumber
          hearingImpairedSupported
          tollFree
        }
      }
    }
  }`;
  return graphQLClient.runQuery(seoQuery, appContext, { requestName: PAGE_HOME });
};

export const fetchHomeConfig = (appContext: AppContext, location: RouterLocation<>) =>
  Promise.all([fetchHomeSeo({ appContext }), dynamicPageService({ appContext, location })]).then(
    ([config, page]) => ({ ...config, ...page }),
  );
